<template>
  <div>
    <base-header
      type="gradient-success"
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
    >
      <div class="row">
        <div class="col-lg-12">
          <h1 class="display-2 text-white">{{gameData ? gameData.name : ''}}</h1>
          <p class="text-white">{{gameData && gameData.active ? 'Active' : 'Inactive'}}</p>
          <a
            href="#!"
            class="btn btn-default"
            @click.prevent="modals.addTeam = true"
          >
            + Add Player
          </a>
          <a
            href="#!"
            class="btn btn-default"
            @click.prevent="modals.importPlayers = true"
          >
            Import Players
          </a>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <card>
            <div slot="header" class="row d-flex align-items-center">
              <div class="col">
                <h3 class="mb-0">Enter Scores</h3>
              </div>
              <div class="col-sm-12 col-md-6 col-lg-3">
                <SearchBox v-model="searchTerm"/>
              </div>
            </div>

            <LiveGameScorecard
              v-for="team in visibleTeams"
              :key="team.id"
              :team="team"
              class="scorecard"
            />

          </card>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.addTeam"
    >
      <h4
        slot="header"
        class="modal-title"
        id="modal-title-default"
      >
        New Team
      </h4>
      <div class="row">
        <div class="col-12">
          <base-input
            alternative=""
            label="Name"
            input-classes="form-control-alternative"
            v-model="addTeamModal.name"
            :error="errors.name"
          />
        </div>
        <div class="col-12">
          <div class="form-group has-label">
            <label class="form-control-label">
              Avatar Image
            </label>
            <input
              type="file"
              class="form-control form-control-alternative"
              ref="file"
              @change="handleFileUpload"
            />
          </div>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          @click="modals.addTeam = false"
        >
          Cancel
        </base-button>
        <base-button
          type="success"
          class="ml-auto"
          @click="addTeam"
          :disabled="loading"
        >
          Save
        </base-button>
      </template>
    </modal>

    <ImportPlayersModal
      :open="modals.importPlayers"
      @close="modals.importPlayers = false"
      @importedTeams="onTeamsAdded"
      :game="gameData"
    />
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import LiveGameScorecard from '@/components/LiveGameScorecard.vue';
import ErrorHandler from '@/helpers/AuthError';
import SearchBox from '@/components/SearchBox.vue';
import ImportPlayersModal from '@/views/LiveGames/ImportPlayersModal.vue';

export default {
  props: {
    id: [String, Number],
  },
  components: {
    LiveGameScorecard,
    SearchBox,
    ImportPlayersModal,
  },
  data() {
    return {
      gameData: {},
      modals: {
        addTeam: false,
        importPlayers: false,
      },
      addTeamModal: {
        name: '',
        file: '',
      },
      errors: {
        name: '',
      },
      loading: false,
      searchTerm: '',
    };
  },
  sockets: {
    updated_team(data) {
      console.log(data);
      if (parseInt(data.livegame.id, 10) !== parseInt(this.id, 10)) {
        return;
      }
      let foundIndex = -1;
      this.gameData.liveteams.forEach((team, index) => {
        console.log(team.id, data.id);
        if (parseInt(team.id, 10) === parseInt(data.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        this.gameData.liveteams[foundIndex].teamName = data.teamName;
        this.gameData.liveteams[foundIndex].thru = data.thru;
        this.gameData.liveteams[foundIndex].total = data.total;
        this.gameData.liveteams[foundIndex].avatar = data.avatar;
      } else {
        this.gameData.liveteams.push(data);
      }
    },
    deleted_team(data) {
      let foundIndex = -1;
      this.gameData.liveteams.forEach((team, index) => {
        if (parseInt(team.id, 10) === parseInt(data.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        this.gameData.liveteams.splice(foundIndex, 1);
      }
    },
    updated_game(data) {
      this.gameData = data;
    },
    deleted_game(data) {
      if (parseInt(this.id, 10) === parseInt(data.id, 10)) {
        this.$router.push({ name: 'view live games' });
      }
    },
  },
  computed: {
    visibleTeams() {
      const originalSet = this.gameData && this.gameData.liveteams ? this.gameData.liveteams : [];

      if (this.searchTerm.length > 0) {
        const options = {
          keys: ['teamName'],
          threshold: 0.1,
        };

        const fuseSearch = new Fuse(originalSet, options);
        const result = fuseSearch.search(this.searchTerm);
        return result.sort((a, b) => String(a.teamName).localeCompare(b.teamName));
      }
      return originalSet.sort((a, b) => String(a.teamName).localeCompare(b.teamName));
    },
  },
  mounted() {
    this.getGame();
  },
  watch: {
    id() {
      this.getGame();
    },
  },
  methods: {
    checkForSubmissionErrors() {
      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          this.errors[key] = '';
        }
      });

      if (this.addTeamModal.name === null || this.addTeamModal.name === '') {
        this.errors.name = 'This field is required';
      }
      if (this.$refs.file.files.length <= 0) {
        this.errors.avatar = 'An avatar is required';
      }
    },
    handleFileUpload() {
      // eslint-disable-next-line prefer-destructuring
      this.addTeamModal.file = this.$refs.file.files[0];
    },
    uploadImage() {
      const formData = new FormData();
      formData.append('files', this.addTeamModal.file);

      return this.axios
        .post('/upload', formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        });
    },
    createTeam() {
      this.loading = true;
      this.uploadImage()
        .then((response) => {
          const newAvatar = {
            avatar: response.data,
          };

          return this.axios
            .post('/liveavatars', newAvatar, {
              headers: {
                Authorization: `Bearer ${this.$store.state.authToken}`,
              },
            });
        })
        .then((response) => {
          const newTeam = {
            teamName: this.addTeamModal.name,
            avatar: response.data.id,
            livegame: this.id,
          };

          return this.axios
            .post('/liveteams', newTeam, {
              headers: {
                Authorization: `Bearer ${this.$store.state.authToken}`,
              },
            })
            .then(() => {
              this.addTeamModal.name = '';
              this.$refs.file.value = '';
              this.addTeamModal.file = '';
              this.modals.addTeam = false;
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              ErrorHandler.handleError(error);
            });
        });
    },
    getGame() {
      this.axios
        .get(`/livegames/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.gameData = response.data;
          this.teams = response.data.liveteams;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    addTeam() {
      this.checkForSubmissionErrors();
      let isOk = true;

      Object.keys(this.errors).forEach((key) => {
        if (this.errors[key]) {
          isOk = false;
        }
      });

      if (!isOk) {
        return;
      }
      this.createTeam();
    },
    onTeamsAdded(teams) {
      if (teams) {
        this.gameData.liveteams.push(...teams);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .scorecard {
    margin-bottom: 1rem;
  }
</style>
